import React, { Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { BrandWorkspacePage, BrandVisionPage, BrandManifestoPage } from './pages/BrandStoryPages';
import BrandHomePage from './pages/BrandHomePage';
import BrandAboutPage from './pages/BrandAboutPage';
import { RoutePosition } from './components/BrandPrimitives';
import { LoginPage } from './pages/LoginPage';
import { AuthCallback } from './components/AuthCallback';
import DashboardPage from './pages/DashboardPage';
import { useAuth } from './components/AuthProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { ApiAccessPage } from './pages/ApiAccessPage';
import { DocumentationPage } from './pages/DocumentationPage';
import BrandCareersPage from './pages/BrandCareersPage';
import { InnovatorsPage } from './pages/InnovatorsPage';
import { BrandJournalPage, BrandJournalPost } from './pages/BrandJournalPages';
import PremiumDownloadPage from './pages/PremiumDownloadPage';
import ChoosePlanPage from './pages/ChoosePlanPage';

export function AppRoutes() {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Show loading state while auth is being verified
    if (isLoading && ['/dashboard', '/callback', '/choose-plan', '/premium-download', '/download'].includes(location.pathname)) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Verifying authentication...</p>
            </div>
        );
    }

    return (
        <ErrorBoundary>
            <Suspense fallback={
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading application...</p>
                </div>
            }>
                <RoutePosition />
                <Routes>
                    <Route path="/" element={
                        isAuthenticated ? (
                            <Navigate to="/dashboard" replace />
                        ) : (
                            <BrandHomePage />
                        )
                    } />
                    <Route path="/desktop" element={
                        isAuthenticated ? (
                            <Navigate to="/dashboard" replace />
                        ) : (
                            <BrandHomePage />
                        )
                    } />
                    <Route path="/workspace" element={<BrandWorkspacePage />} />
                    <Route path="/landing" element={<Navigate to="/workspace" replace />} />

                    <Route path="/login" element={
                        isAuthenticated ? (
                            <Navigate to="/dashboard" replace />
                        ) : (
                            <LoginPage />
                        )
                    } />

                    <Route path="/callback" element={<AuthCallback />} />

                    <Route path="/premium-download" element={<PremiumDownloadPage />} />
                    <Route path="/choose-plan" element={<ChoosePlanPage />} />

                    <Route path="/dashboard" element={
                        isAuthenticated ? (
                            <DashboardPage />
                        ) : (
                            <Navigate to="/login" replace state={{ from: location }} />
                        )
                    } />

                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/about" element={<BrandAboutPage />} />
                    <Route path="/about-us" element={<Navigate to="/about" replace />} />
                    <Route path="/vision" element={<BrandVisionPage />} />
                    <Route path="/api" element={<ApiAccessPage />} />
                    <Route path="/documentation" element={<DocumentationPage />} />
                    <Route path="/manifesto" element={<BrandManifestoPage />} />
                    <Route path="/careers" element={<BrandCareersPage />} />
                    <Route path="/innovators" element={<InnovatorsPage />} />
                    <Route path="/blog" element={<BrandJournalPage />} />
                    <Route path="/blog/:slug" element={<BrandJournalPost />} />
                    <Route path="/download" element={<PremiumDownloadPage />} />


                    {/* Catch all route */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Suspense>
        </ErrorBoundary>
    );
}
